export default __webpack_public_path__ + "static/media/logo-login.f6a3acc5.svg";